import './SkeletonBox-248bfcc3.css';

var classes = {"SkeletonBox":"prc-Skeleton-SkeletonBox-nSZk3"};

export { classes as default };
